import Store, { StoreName } from '~/types/Store';
import { ActionKeys } from './constants';

function fetchStores() {
  return <const>{
    type: ActionKeys.STORES_FETCH,
  };
}

function fetchStoresError(errorMessage: string) {
  return <const>{
    errorMessage,
    type: ActionKeys.STORES_FETCH_ERROR,
  };
}

function fetchStoresSuccess(stores: Store[]) {
  return <const>{
    type: ActionKeys.STORES_FETCH_SUCCESS,
    payload: {
      stores,
    },
  };
}

function editStoreSuccess(store: Store) {
  return <const>{
    type: ActionKeys.STORE_EDIT_SUCCESS,
    payload: {
      store: store,
    },
  };
}

function fetchLegacyStores() {
  return <const>{
    type: ActionKeys.LEGACY_STORES_FETCH,
  };
}

function fetchLegacyStoresError(errorMessage: string) {
  return <const>{
    errorMessage,
    type: ActionKeys.LEGACY_STORES_FETCH_ERROR,
  };
}

function fetchLegacyStoresSuccess(stores: Store[]) {
  return <const>{
    type: ActionKeys.LEGACY_STORES_FETCH_SUCCESS,
    payload: {
      stores,
    },
  };
}

function disconnectStore(storeName: StoreName, objectId: string) {
  return <const>{
    type: ActionKeys.DISCONNECT_STORE,
    payload: {
      storeName,
      objectId,
    },
  };
}

function disconnectStoreSuccess(storeName: StoreName) {
  return <const>{
    storeName,
    type: ActionKeys.DISCONNECT_STORE_SUCCESS,
  };
}

function disconnectStoreError(storeName: StoreName, errorMessage: string) {
  return <const>{
    storeName,
    errorMessage,
    type: ActionKeys.DISCONNECT_STORE_ERROR,
  };
}

function editStore(store: Store) {
  return <const>{
    payload: {
      store,
    },
    type: ActionKeys.STORE_EDIT,
  };
}

export {
  fetchStores,
  fetchStoresError,
  fetchStoresSuccess,
  fetchLegacyStores,
  fetchLegacyStoresError,
  fetchLegacyStoresSuccess,
  disconnectStore,
  disconnectStoreSuccess,
  disconnectStoreError,
  editStore,
  editStoreSuccess,
};

export type StoresActions =
  | ReturnType<typeof fetchStores>
  | ReturnType<typeof fetchStoresError>
  | ReturnType<typeof fetchStoresSuccess>
  | ReturnType<typeof fetchLegacyStores>
  | ReturnType<typeof fetchLegacyStoresError>
  | ReturnType<typeof fetchLegacyStoresSuccess>
  | ReturnType<typeof disconnectStore>
  | ReturnType<typeof disconnectStoreSuccess>
  | ReturnType<typeof editStore>
  | ReturnType<typeof editStoreSuccess>
  | ReturnType<typeof disconnectStoreError>;
